import React, { FunctionComponent, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { MyTextFiled } from '../UI/MyTextField';
import { AnnotaionDto } from '../../dto/LectionImageDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { apiAddAnnatation } from '../../service/apiAddAnnatation';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  convertHtmlToText,
  convertTextToHtml,
  formId,
  getDefaultAlertProps,
  getPageNumId,
} from '../../utils/utils';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyButton } from '../UI/MyButton';
import { MyAlert } from '../UI/MyAlert';

interface Props {
  idPage: string;
  open: boolean;
  onClose: () => void;
  onSave: (e: any) => void;
}

export const DialogAddAnnotation: FunctionComponent<Props> = ({
  idPage,
  open,
  onClose,
  onSave,
}) => {
  const [annatationDto, setAnnatationDto] = useState<AnnotaionDto>({
    id: '',
    title: '',
    text: '',
  });
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);
  const handleClose = () => {
    setAnnatationDto({
      id: '',
      title: '',
      text: '',
    });
    onClose();
  };
  const handleSave = (id: string) => {
    onSave(id);
  };
  const [checkHelper, setCheckHelper] = useState(false);
  const { section, route } = useParams();
  const page = getPageNumId(idPage);
  const addAnnatattion = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddAnnatation(
      section ?? '',
      route ?? '',
      page ?? '',
      annatationDto
    );
    if (apiResult.isSuccess) {
      handleSave(annatationDto.id);
      handleClose();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleAdd = async () => {
    if (annatationDto.text === '') {
      setCheckHelper(true);
      return;
    }
    await addAnnatattion();
    setCheckHelper(false);
  };

  useEffect(() => {
    setAnnatationDto({
      id: '',
      title: '',
      text: '',
    });
    setCheckHelper(false);
  }, []);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        style={{ userSelect: 'none' }}
        PaperProps={{ sx: { backgroundColor: '#e7ebee', width: '100%' } }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              Новый термин
            </Typography>
            <IconButton size="medium" onClick={onClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack padding="0px" spacing={1}>
            {false && (
              <MyTextFiled
                value={annatationDto.title}
                onChange={(e) =>
                  setAnnatationDto({
                    ...annatationDto,
                    title: e.target.value,
                  })
                }
                size="small"
                label="Термин"
              />
            )}
            <MyTextFiled
              value={convertHtmlToText(annatationDto.text)}
              onChange={(e) =>
                setAnnatationDto({
                  ...annatationDto,
                  text: convertTextToHtml(e.target.value),
                  id: `${formId(e.target.value, page || '')}`,
                })
              }
              error={checkHelper}
              multiLine
              size="small"
              label="Пояснение"
            />
            <Stack paddingTop="20px" alignItems="center">
              <MyButton
                width="120px"
                text="Добавить"
                background="#9c27b0"
                height="50px"
                onClick={handleAdd}
              />
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
